/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC } from 'react'
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { Reseller } from '../../core/_models'

type Props = {
  reseller: Reseller
}
const img_url = 'http://127.0.0.1:8000/storage/thumbnail_images/reseller/';//this is the ser
const ResellerInfoCell: FC<Props> = ({ reseller }) =>{
  return(
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
        <a href='#'>
          {reseller.profile_image_url ? (
            <div className='symbol-label'>
              <img src={`${reseller.profile_image_url}`} alt={reseller.reseller_name} className='w-100' />
            </div>
          ) : (
            <div
              className={clsx(
                'symbol-label fs-3',
                `bg-light-${reseller.districts_id}`,
                `text-${reseller.balance}`
              )}
            >
            </div>
          )}
        </a>
      </div>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-primary mb-1'>
          {reseller.email}
        </a>
        <span>{reseller.reseller_name}</span>
      </div>
    </div>
  )
}

export { ResellerInfoCell }
